import { createFileRoute } from '@tanstack/react-router';
import { ClipperPage } from '@/features/campaigns/clipper-page';

export const Route = createFileRoute('/_authenticated/campaigns/$id/clipper')({
    head: () => ({ meta: [{ title: 'Campaign Clipper | promote.fun' }] }),
    component: ClipperPage,
});
